import React from "react";
import "./printCss.css";
import guamLogo from "../../../../../assets/GuamSeal.svg";
import guamLogo2 from "../../../../../assets/GuamLogo.png";
import { Col, Row } from "reactstrap";
import moment from "moment";

const AmendmentPrint = (props) => {
    const {data} = props

    console.log("dsadadadas", data);
  return (
    <>
      <div style={{padding:"10px"}}> 
        <div style={{ display: "flex" }}>
          <div style={{ width: "30%", textAlign: "left" }}>
            <span
              style={{
                float: "left",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <img src={guamLogo2} alt="Logo 1" style={{ height: "60px" }} />
              <p className="tophead">EDWARD M. BIRN</p>
              <p className="tophead">Director (Direktot)</p>
              <p className="tophead">ELIZABETH T. FISHER</p>
              <p className="tophead">Deputy Director (Sigundo Direktot)</p>
            </span>
          </div>
          <div style={{ width: "40%", textAlign: "center" }}>
            <div style={{ display: "inline-block", color: "green    " }}>
              <h1
                className="admin1"
                style={{ fontSize: "24px", fontWeight: "700" }}
              >
                DEPARTMENT OF ADMINISTRATION
              </h1>
              <h3 className="admin1" style={{ fontSize: "16px" }}>
                DIPATTAMENTON AMETNESTRASYON
              </h3>
              <h4
                className="admin1"
                style={{ fontSize: "13px", fontWeight: "700" }}
              >
                HUMAN RESOURCES DIVISION
              </h4>
              <h3
                className="admin1"
                style={{ fontSize: "13px", fontWeight: "600" }}
              >
                (Dibision Inadilanto yan Guinaha Para Taotao)
              </h3>
              <h6
                className="tophead"
                style={{ fontSize: "12px", fontStyle: "italic" }}
              >
                Telephone (Telifon): (671) 475-1288/1103 . Fax (Faks): (671)
                477-3671
              </h6>
            </div>
          </div>
          <div style={{ width: "30%", textAlign: "right" }}>
            <span
              style={{
                float: "right",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <img src={guamLogo} alt="Logo 2" style={{ height: "60px" }} />
              <p className="tophead">LOURDES A. LEON GUERRERO</p>
              <p className="tophead">Governor (Maga’håga)</p>
              <p className="tophead">JOSHUA F. TENORIO</p>
              <p className="tophead">Lt. Governor (Sigundo Maga’låhi)</p>
            </span>
          </div>
        </div>
        <div className="examination">
          <h2 className="examination1" style={{ fontSize: "24px" }}>
            AMENDMENT OF JOB ANNOUNCEMENT
          </h2>
          <div className="examination2">
            <div className="maincontent">
              <div className="examination2-content">
                <div className="dateInfo">
                  <b>{data?.AmendmentDate ? moment(data?.AmendmentDate).format("MMMM DD, YYYY") :""}</b>
                </div>
              </div>
              <div
                className="cont-6"
                style={{ marginTop: "20px", marginLeft: "15px",textAlign:'center' }}
              >
                <b style={{textAlign:'center'}}>
                {data?.AmendmentText?.toUpperCase()}
                  {/* THE FOLLOWING JOB ANNOUNCEMENTS BELOW ARE AMENDED TO CLOSE ON
                  OCTOBER 21, 2022. */}
                </b>
              </div>
              <div style={{marginBottom:"20px"}}>
                <table
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginTop: "20px",
                  }}
                >
                  <thead>
                    <th>ANN.#</th>
                    <th>POSITION TITLE:</th>
                    <th>CLOSING:</th>
                  </thead>
                  <tr>
                    <th>{data?.announcementId}</th>
                    <th>{data?.positionTitle}</th>
                    <th>{data?.dateClosed ? moment(data?.dateClosed).format("MM-DD-YYYY") : null}</th>
                  </tr>
                  <tr>
                    {/* <td colSpan={3}>
                       <div style={{marginTop:"20px", marginLeft:"20px"}}>
                <span style={{display:"flex"}}><h4 className="amdDetail">Amendment Detail : </h4><span>&nbsp;{data?.AmendmentText}</span></span>
              </div>
                    </td> */}
                  </tr>
                  {/* <tr>
                    <th>DOA200-22</th>
                    <th>CHIEF OF OPERATIONS</th>
                    <th>10/21/2022</th>
                  </tr>
                  <tr>
                    <th>DOA2O2-22</th>
                    <th>PLANNER II</th>
                    <th>10/21/2022</th>
                  </tr>
                  <tr>
                    <th>D0A203-22</th>
                    <th>PROGRAM COORDINATOR I</th>
                    <th>10/21/2022</th>
                  </tr>
                  <tr>
                    <th>D0A205-22</th>
                    <th>YOUTH SERVICE WORKER ASSISTANT</th>
                    <th>10/21/2022</th>
                  </tr> */}
                </table>
              </div>

             
            </div>
          </div>
          <div style={{marginTop:"20px", marginLeft:"20px"}}>
              For further information, please call (671) 475-1141/11128.
          </div>
             
              <Row style={{ marginTop: "200px" }}>
          <Col sm={4}></Col>
          <Col sm={4}>
            <div style={{ borderBottom: "1px solid black" }}></div>
            <div style={{ fontSize: "14px", textAlign: "center" }}>
              Appointing Authority
            </div>
          </Col>
          <Col sm={4}></Col>
        </Row>

        <Row style={{ marginTop: "40px",padding:"15px" }}>
          <Col sm={12}>
            {/* <b> */}
            WE ARE AN EQUAL EMPLOYMENT OPPORTUNITY EMPLOYER. WE DO NOT
            DISCRIMINATE ON THE BASIS OF RACE, RELIGION, COLOR, SEX, AGE,
            DISABILITY, EXCEPT FOR POSITIONS REQUIRING BONA FIDE OCCUPATIONAL
            QUALIFICATION.
            {/* </b> */}
          </Col>
        </Row>
        </div>
      </div>
      
    </>
  );
};

export default AmendmentPrint;
